<h1 mat-dialog-title>Fechamento de venda</h1>
<div mat-dialog-content class="full-width">
    <mat-form-field appearance="fill">
        <mat-label>Valor Total a Pagar</mat-label>
        <input matInput currencyMask [(ngModel)]="data.pagar"
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" disabled/>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
        <mat-label>Valor Pago</mat-label>
        <input matInput currencyMask [(ngModel)]="data.pago" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
            (ngModelChange)="calc()" required>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
        <mat-label>Forma de pagamento</mat-label>
        <mat-select id="pagamento" name="pagamento" [(value)]="data.payment" required disabled>
            <mat-option [value]="payment" *ngFor="let payment of payments">{{payment}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-checkbox class="example-margin" [(ngModel)]="checked">Habilitar Mais Pagamento</mat-checkbox>
    <br>
    <mat-form-field appearance="fill" *ngIf="checked">
        <mat-label>Valor Pago</mat-label>
        <input matInput currencyMask [(ngModel)]="data.pago2" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
            (ngModelChange)="calc()">
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill" *ngIf="checked">
        <mat-label>Forma de pagamento</mat-label>
        <mat-select id="pagamento2" name="pagamento2" [(value)]="data.payment2">
            <mat-option [value]="payment" *ngFor="let payment of payments">{{payment}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
        <mat-label>Troco</mat-label>
        <input matInput currencyMask readonly [(ngModel)]="data.troco"
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button [disabled]="data.troco<0 || data.payment==null" mat-button [mat-dialog-close]="data"
        cdkFocusInitial>Confirmar Venda</button>
</div>